

class  Dispatcher{

    constructor() {
        this.handlers = [];
    }

    add(scope,name,command, handler) {
        this.handlers.push({scope:scope,name:name,command:command, handler:handler}); 
    }

    removeScope(scope) {
        let l=this.handlers.length;
        for(let i=0;i<l;i++){
            if(this.handlers[i].scope===scope){
                this.handlers.splice(i, 1);
                i--;
                l=this.handlers.length;
            }
        }
    }

    removeName(name) {
        let l=this.handlers.length;
        for(let i=0;i<l;i++){
            if(this.handlers[i].name===name){
                this.handlers.splice(i, 1);
                i--;
                l=this.handlers.length;
            }
        }
    }

    removeScopeName(scope,name) {
        let l=this.handlers.length;
        for(let i=0;i<l;i++){
            if((this.handlers[i].scope===scope) && (this.handlers[i].name===name)){
                this.handlers.splice(i, 1);
                i--;
                l=this.handlers.length;
            }
        }

    }

    run(scope,name,command,params=[]) {
        let l=this.handlers.length;
        for(let i=0;i<l;i++){
            if((this.handlers[i].scope===scope) && (this.handlers[i].name===name) && (this.handlers[i].command===command)){
                if(params.length>0){
                    this.handlers[i].handler(...params);
                }else{
                    this.handlers[i].handler();
                }
            }
        }
    }

}

export default Dispatcher;
